
import Vue, { PropType } from "vue";
import { CompanyUser } from "@/models";

import CompanyUserListItem from "./CompanyUserListItem.vue";

export default Vue.extend({
  name: "CompanyUserList",

  props: {
    companyUsers: Array as PropType<Array<CompanyUser>>
  },

  components: {
    CompanyUserListItem
  }
});
